import { createSlice } from '@reduxjs/toolkit';

const initialData = {
  landing_info_catalog: "Lo más nuevo en diseño",
  landing_info_app: "App Perfiletto te permite generar tablas de corte para cancelería de aluminio; de una manera simple y precisa.",
  timestamp: 0,
  locale: 'es',
  landing_multimedia: null,
};

export const settingsSlice = createSlice({
  name: 'info',
  initialState: initialData,
  reducers: {
    setLandingMultimedia: (state, action) => {
      const landingData = action.payload.data;
      // Garantiza que dynamic_content siempre exista y sea un array
      const isValid = 
        landingData && 
        typeof landingData === 'object' && 
        Array.isArray(landingData.dynamic_content);
      const safeData = isValid ? landingData : null;
      
      return {
        ...state,
        timestamp: Date.now(),
        landing_multimedia: safeData,
        locale: action.payload.locale,
      };
    },
  }
});

export const {
  setLandingMultimedia
} = settingsSlice.actions;

export default settingsSlice.reducer;